import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IOAuth2Client } from "@sso/oauth2-clients/contracts";
import { NormalPaginated } from "@types";
import { useSsoOAuth2Url } from "@common/hooks/useSsoOauth2Url";

export function useOAuth2Client(id: number) {
  const { request } = useSsoOAuth2Url();

  return useQuery("oauth2client:" + id, async () => {
    const { oAuthClients } = await request(
      gql`
        query oAuthClients($filter: OAuthClientFilter) {
          oAuthClients(filter: $filter, limit: 1) {
            data {
              id
              secret
              name
              type
              redirects
              revoked
              tokenExpiration
              user {
                uuid
                name
              }
            }
          }
        }
      `,
      { filter: { id } }
    );
    const paginatedResults = oAuthClients as NormalPaginated<IOAuth2Client>;
    return paginatedResults.data?.[0];
  });
}
